var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDonateCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9218_396)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9218_396)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 4,
    fill: "#0EDC1C"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_9218_396)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9218_396",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 35,
    height: 35
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 35,
    height: 35,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9218_396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3077 33.8261V24.4737L12.0396 25.4565C11.7437 25.6679 11.4266 25.7524 11.0885 25.7101C10.7503 25.6679 10.4755 25.4988 10.2642 25.2029C10.0528 24.907 9.9683 24.59 10.0106 24.2518C10.0528 23.9136 10.2114 23.6389 10.4861 23.4275L13.3077 21.2717V18.6087C13.3077 18.2494 13.4292 17.9482 13.6723 17.7052C13.9153 17.4621 14.2165 17.3406 14.5758 17.3406C14.9351 17.3406 15.2363 17.4621 15.4793 17.7052C15.7224 17.9482 15.8439 18.2494 15.8439 18.6087V19.3379L21.8992 14.7092C22.1316 14.5402 22.38 14.4133 22.6442 14.3288C22.9084 14.2443 23.1778 14.202 23.4526 14.202C23.7274 14.202 23.9968 14.2443 24.261 14.3288C24.5252 14.4133 24.7736 14.5402 25.006 14.7092L36.4191 23.4275C36.6938 23.6389 36.8524 23.9136 36.8946 24.2518C36.9369 24.59 36.8524 24.907 36.641 25.2029C36.4296 25.4777 36.1549 25.6362 35.8167 25.6784C35.4786 25.7207 35.1721 25.6362 34.8973 25.4248L33.5975 24.4737V33.8261C33.5975 34.5236 33.3492 35.1206 32.8525 35.6173C32.3558 36.114 31.7588 36.3623 31.0613 36.3623H25.3548C25.1857 36.3623 25.0377 36.2989 24.9109 36.1721C24.7841 36.0453 24.7207 35.8973 24.7207 35.7283V30.0217C24.7207 29.6624 24.5992 29.3613 24.3561 29.1182C24.1131 28.8752 23.8119 28.7536 23.4526 28.7536C23.0933 28.7536 22.7921 28.8752 22.5491 29.1182C22.306 29.3613 22.1845 29.6624 22.1845 30.0217V35.7283C22.1845 35.8973 22.1211 36.0453 21.9943 36.1721C21.8675 36.2989 21.7195 36.3623 21.5504 36.3623H15.8439C15.1464 36.3623 14.5494 36.114 14.0527 35.6173C13.556 35.1206 13.3077 34.5236 13.3077 33.8261ZM14.9562 16.0725C14.4701 16.0725 14.095 15.8717 13.8308 15.4701C13.5666 15.0685 13.5507 14.6564 13.7832 14.2337C14.1425 13.6208 14.6128 13.1399 15.194 12.7912C15.7752 12.4425 16.4146 12.2681 17.112 12.2681C17.3445 12.2681 17.5664 12.21 17.7778 12.0938C17.9891 11.9775 18.1476 11.8137 18.2533 11.6024C18.359 11.4121 18.5017 11.2642 18.6813 11.1585C18.861 11.0528 19.067 11 19.2995 11C19.7856 11 20.1555 11.2008 20.4091 11.6024C20.6627 12.0039 20.6733 12.4161 20.4408 12.8388C20.0815 13.4517 19.6113 13.9325 19.03 14.2812C18.4488 14.63 17.8095 14.8043 17.112 14.8043C16.8795 14.8043 16.6576 14.8572 16.4463 14.9629C16.2349 15.0685 16.0764 15.2376 15.9707 15.4701C15.865 15.6603 15.7277 15.8083 15.5586 15.9139C15.3895 16.0196 15.1887 16.0725 14.9562 16.0725Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9218_396",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9218_396"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9218_396",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_9218_396",
    x: 4,
    y: 5,
    width: 46.9043,
    height: 45.3633,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9218_396"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9218_396",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9218_396"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonateCenter);
export default __webpack_public_path__ + "static/media/donate-center.d3907d52447b1904d14e9543a5bc2291.svg";
export { ForwardRef as ReactComponent };